"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobxStateTree = require("mobx-state-tree");

var _mst = require("../../util/types/mst");

var BaseViewModel = _mobxStateTree.types.model('BaseView', {
  id: _mst.ElementId,
  displayName: _mobxStateTree.types.maybe(_mobxStateTree.types.string)
}).volatile(function () {
  return (
    /* self */
    {
      width: 800
    }
  );
}).views(function () {
  return (
    /* self */
    {
      get menuItems() {
        return [];
      }

    }
  );
}).actions(function (self) {
  return {
    setDisplayName: function setDisplayName(name) {
      self.displayName = name;
    },
    setWidth: function setWidth(newWidth) {
      self.width = newWidth;
    }
  };
});

var _default = BaseViewModel; // eslint-disable-next-line @typescript-eslint/no-empty-interface,@typescript-eslint/interface-name-prefix

exports.default = _default;